






































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { CourseListenersList as ICourseListenersList } from "@/api/models/course-listeners-list";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { User as IUser } from "@/api/models/user";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import courseListeners, {
  CourseListenersListParams
} from "@/getinfo-api/course-listeners";
import { Course as ICourse } from "@/api/models/course";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
import Modal from "@/components/form/Modal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CCheckbox from "@/components/form/CCheckbox.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import {
  isAllowEditDates,
  learningGroupModule,
  studentLimitModule
} from "@/plugins/modules-detect";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import SearchUser from "@/components/user/SearchUser.vue";
import { uniqBy } from "lodash";
import LearningGroupTableByCourseId from "@/components/learning-group/LearningGroupTableByCourseId.vue";
@Component({
  components: {
    LearningGroupTableByCourseId,
    SearchUser,
    CBlock,
    CField,
    CustomDatepicker,
    CCheckbox,
    CustomButton,
    Modal,
    TableActions,
    CustomTableCol,
    CustomTableItem,
    CustomTable
  }
})
export default class UsersActionAdmin extends Vue {
  @Prop() course!: ICourse;
  courseListener!: ICourseListenersList;
  isEditDateShow: boolean = false;
  usersList: Array<IUser> = [];
  searchUsersByEmail!: string;
  searchListenerByEmail!: string;
  visibleSpinner: boolean = false;
  limitedUsers: Array<ICourseListener> = [];
  limit: number = 30;
  offset: number = 0;
  listenerCount: number = 0;
  showSpinner: boolean = false;
  button: boolean = true;
  id?: string;
  disabled: boolean = false;
  editableListener!: string | undefined;
  createdAt!: Date;
  userRegisteredAtMin!: Date | undefined;
  userRegisteredAtMax!: Date | undefined;
  filteredListeners: Array<IUser> = [];

  data() {
    return {
      userRegisteredAtMin: undefined,
      userRegisteredAtMax: undefined,
      id: undefined,
      courseListener: undefined,
      filteredUsersList: undefined,
      searchUsersByEmail: "",
      searchListenerByEmail: undefined,
      visibleSpinner: false,
      isCourseOwner: undefined,
      editableListener: undefined,
      createdAt: undefined
    };
  }

  changeListenerDate(id: string, date: Date) {
    api.CourseApi.listenerEditCreatedAt(date, this.course.id, id)
      //@ts-ignore
      .then((res: { data: ICourseListener }) => {
        let index = this.limitedUsers.findIndex(
          (el: ICourseListener) => el.id === id
        );
        this.limitedUsers[index] = res.data;
        this.searchListenerByEmail = " ";
        this.searchListenerByEmail = "";
        this.changeShowEditDate(this.limitedUsers[index]);
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get isLearningGroupModule() {
    return learningGroupModule();
  }

  submitChanges() {
    this.searchUsersByEmail = "";
    this.limitedUsers = [];
    this.usersList = [];
    this.offset = 0;
    this.initCourseListener();
  }

  get isStudentLimitModule() {
    return studentLimitModule() && this.$store.state.studentLimit !== 0;
  }

  clearFilter() {
    this.searchListenerByEmail = "";
    this.userRegisteredAtMin = undefined;
    this.userRegisteredAtMax = undefined;
    this.limitedUsers = [];
    this.initCourseListener();
  }

  addToCourse(userId: string) {
    this.visibleSpinner = true;
    this.searchListenerByEmail = "";
    this.$store.state.studentAmount++;
    api.CourseApi.listenerAdd(this.course.id, userId)
      .then(() => {
        this.searchUsersByEmail = "";
        this.usersList = [];
        this.offset = 0;
        this.limitedUsers = [];
        this.initCourseListener();
      })
      .catch((error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
        this.$store.state.studentAmount--;
        if (error.response) {
          this.$bvToast.toast(error.response.data.message, {
            variant: "danger",
            title: `${this.$tc(this.$translate.Error)}`
          });
        }
      })
      .finally(() => {
        this.visibleSpinner = false;
      });
  }

  get listenerByEmail() {
    return this.limitedUsers;
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  changeShowEditDate(listener: ICourseListener) {
    this.editableListener = undefined;
    this.editableListener = listener.id;
    this.createdAt = listener.createdAt;
    this.isEditDateShow = !this.isEditDateShow;
  }

  showMore() {
    this.offset += this.limit;
    this.initCourseListener(this.offset);
  }

  async initCourseListener(offset: number = 0) {
    this.limitedUsers = uniqBy(this.limitedUsers, "id");
    this.visibleSpinner = true;
    let paramsWithEmail: CourseListenersListParams = {
      id: this.course.id,
      limit: this.limit,
      email: this.searchListenerByEmail //this
        ? this.searchListenerByEmail
        : undefined,
      offset: offset,
      registeredAtMin: this.userRegisteredAtMin,
      registeredAtMax: this.userRegisteredAtMax
        ? new Date(this.userRegisteredAtMax.setHours(23, 59))
        : undefined
    };

    let paramsWithFullName: CourseListenersListParams = {
      id: this.course.id,
      limit: this.limit,
      offset: offset,
      registeredAtMin: this.userRegisteredAtMin,
      registeredAtMax: this.userRegisteredAtMax
        ? new Date(this.userRegisteredAtMax.setHours(23, 59))
        : undefined,
      fullName: this.searchListenerByEmail
        ? this.searchListenerByEmail
        : undefined
    };

    await Promise.allSettled(
      [paramsWithEmail, paramsWithFullName].map(async params => {
        const response = await courseListeners(params);
        this.listenerCount = response.data.count;
        this.limitedUsers = [...this.limitedUsers, ...response.data.listeners];
        this.limitedUsers = uniqBy(this.limitedUsers, "id");
      })
    );

    this.visibleSpinner = false;
  }

  changeListenerEnabled(index: number) {
    if (this.listenerByEmail[index].enabled) {
      this.disabled = true;
      api.CourseApi.listenerDisable(
        this.course.id,
        this.listenerByEmail[index]?.id
      )
        .then((res: { data: any }) => {
          this.listenerByEmail[index].enabled = res.data.enabled;
        })
        .finally(() => {
          this.disabled = false;
        });
    }

    if (this.listenerByEmail[index]?.enabled === false) {
      this.disabled = true;
      api.CourseApi.listenerEnable(
        this.course.id,
        this.listenerByEmail[index].id
      )
        .then((res: { data: any }) => {
          if (res.data.enabled === false) {
            this.$store.dispatch(
              "localError",
              `${this.$tc(
                this.$translate
                  .UserHasAlreadyCompletedTrainingIfYouNeedToRetrain
              )}`
            );
          }
          this.listenerByEmail[index].enabled = res.data.enabled;
        })
        .finally(() => {
          this.disabled = false;
        });
    }
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return this.userId === this.course?.company?.owner?.id;
  }

  get courseOwner() {
    return this.userId === this.course?.owner?.id;
  }

  get grantedForComponent() {
    return this.root || this.companyOwner || this.courseOwner;
  }

  created() {
    this.grantedForComponent ? this.initCourseListener() : false;
  }

  removeListener(id: string) {
    api.CourseApi.listenerDelete(this.course.id, id)
      .then(() => {
        this.offset = 0;
        this.limitedUsers = [];
        this.initCourseListener();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
}
